import { UseFormReturn } from "react-hook-form";
import { ProjectViewFormData } from "./schema";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";

export function ProjectViewForm({ form }: { form: UseFormReturn<ProjectViewFormData> }) {

  return (
    <div className="space-y-8">
      {/* VISUAL DO PROJETO */}
      <div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Link da Apresentação/Materiais Gráficos */}
          <FormField
            control={form.control}
            name="presentationMaterialsLink"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="text-white">Link da Apresentação/Materiais Gráficos</FormLabel>
                <FormControl>
                  <Input placeholder="Digite aqui" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* Link do Vídeo de Apresentação/Teaser */}
          <FormField
            control={form.control}
            name="videoTeaserLink"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="text-white">Link do Vídeo de Apresentação/Teaser</FormLabel>
                <FormControl>
                  <Input placeholder="Digite aqui" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </div>
    </div>
  );
}